/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreTimesheetResponseDto } from '../../models/core-timesheet-response-dto';

export interface TimesheetsControllerFindByProjectAndPeriod$Params {
  tenant: string;
  projectId: string;

/**
 * ISO start date
 */
  from: string;

/**
 * ISO end date
 */
  to: string;

/**
 * Optional contract id. When provided, only timesheets billed against that contract are returned — used by the vacation payment review on a mixed project so each contract sees only its own period timesheets.
 */
  contractId?: string;
}

export function timesheetsControllerFindByProjectAndPeriod(http: HttpClient, rootUrl: string, params: TimesheetsControllerFindByProjectAndPeriod$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreTimesheetResponseDto>>> {
  const rb = new CoreRequestBuilder(rootUrl, timesheetsControllerFindByProjectAndPeriod.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('projectId', params.projectId, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('contractId', params.contractId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<Array<CoreTimesheetResponseDto>>;
    })
  );
}

timesheetsControllerFindByProjectAndPeriod.PATH = '/o2-core/timesheets/{tenant}/project/{projectId}/period';
